import { Component } from '@angular/core';

@Component({
  selector: 'app-software-assurance',
  standalone: false,
  templateUrl: './software-assurance.component.html',
  styleUrl: './software-assurance.component.css'
})
export class SoftwareAssuranceComponent {

}
